import { Info } from '@phosphor-icons/react';
import { IconTooltipButton, SimpleTooltip } from '../components/ui/tooltip';
import { cn } from '../lib/utils';

interface InfoTooltipProps {
  /** Accessible name of the trigger — a bare icon has none of its own. */
  label: string;
  children: string;
  className?: string;
}

export function InfoTooltip({ label, children, className }: InfoTooltipProps) {
  return (
    <SimpleTooltip content={children}>
      <IconTooltipButton label={label} className={cn('shrink-0', className)}>
        <Info className="text-muted-foreground size-3.5" />
      </IconTooltipButton>
    </SimpleTooltip>
  );
}
